import React from 'react';
import styled from 'styled-components';

export const StyledCard = styled.div`
  border: 1px solid #C1C1C1;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background-color: #ffffff;
  padding: 1em;
  
  margin-bottom: 1.5em;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 992px){
    height: 100%;
    margin-bottom: 0;
  }
`;

export const Card = ({children, title, overrideStyle, className}) => (
  <StyledCard style={overrideStyle} className={className}>
    {title && <h5 style={{'fontWeight': 'bold'} }>
      {title}
    </h5>
    }
    {children}
  </StyledCard>
);
